import { IGameView } from "./../../entities";
import { provider } from "../../providers";

export interface GetGameViewByIdPayload {
  id: number;
}

export const GetGameViewById = async (params: GetGameViewByIdPayload): Promise<IGameView | null> =>
  provider.Request("/games/view/{id}", params);
